import React, { PropTypes } from 'react'
import { connect } from 'react-redux'
import Table from 'react-bootstrap/lib/Table'
import acc from 'accounting'

import { makeGetSelected } from 'containers/Enrolment/selectors'

import ListSelectedItem from './list-selected-item'

const ListSelected = ({ __selected }) => {
  let total = 0
  return (
    <div>
      <Table condensed className="table--cor">
        <thead>
          <tr>
            <th width="3%"></th>
            <th width="10%">Code</th>
            <th width="8%">Section</th>
            <th>Subject Description</th>
            <th width="20%">Schedule</th>
            <th width="5%" className="text-right">Lec</th>
            <th width="5%" className="text-right">Lab</th>
            <th width="5%" className="text-right">Units</th>
            <th width="15%">Instructor</th>
          </tr>
        </thead>
        <tbody>
          {__selected.map((item, k) => {
            total += item.get('units') - 0
            return (
              <ListSelectedItem
                key={k}
                item={item}
              />
            )
          })}
        </tbody>
        <tfoot>
          <tr>
            <th colSpan="7" className="text-right">Total Units:</th>
            <th className="text-right">{acc.formatNumber(total, 1)}</th>
            <th></th>
          </tr>
        </tfoot>
      </Table>
    </div>
  )
}

ListSelected.propTypes = {
  __selected: PropTypes.object,
}

function mapStateToProps(state) {
  const getSelected = makeGetSelected()
  return {
    __selected: getSelected(state),
  }
}

export default connect(mapStateToProps)(ListSelected)



// WEBPACK FOOTER //
// ./src/containers/Enrolment/Apply/list-selected.js